import axios from 'axios';
import qs from 'qs';
import { __ } from '@wordpress/i18n';

export default ( {
	saving,
	reseting,
	setReseting,
	setSaving,
	getOptionsId,
	allOptions,
	resetOptions,
	updateNotSaved
} ) => (
	<>
		<button className="options-kit-reset" disabled={ ( saving || reseting ) } onClick={ ( e ) => {
			e.preventDefault();
			if ( saving || reseting ) {
				return;
			}

			setReseting( true );

			axios.post( optionsKitAjaxUrl, qs.stringify( {
				action: 'options_kit_reset',
				nonce: optionKitNonce,
				option_id: optionKitId,
				options: getOptionsId( kitOptions ),
			} ) ).then( r => {
				if ( r.data !== undefined && r.data.success ) {
					resetOptions();
				}
				setReseting( false );
			} );
		} }>{ __( 'Reset', 'wp-offers' ) }</button>
		<button className="options-kit-save" disabled={ ( saving || reseting ) } onClick={ ( e ) => {
			e.preventDefault();

			if ( saving ) {
				return;
			}

			setSaving( true );

			axios.post( optionsKitAjaxUrl, qs.stringify( {
				action: 'options_kit_save',
				nonce: optionKitNonce,
				option_id: optionKitId,
				options: allOptions,
			} ) ).then( r => {
				setSaving( false );
				updateNotSaved( false );
			} );
		} }>
			{
				saving ?
				__( 'Saving...', 'wp-offers' )
				:
				__( 'Save Settings', 'wp-offers' )
			}
			{
				saving &&
				<span className="dashicons dashicons-update"></span>
			}
		</button>
	</>
);
